import { type AutomationEdgeType } from './AutomationEdgeType';
import { type AutomationNodeType } from './AutomationNodeType';
import { type AutomationType } from './AutomationType';

export enum AutomationExecutionStatusEnum {
  PENDING = 'pending',
  RUNNING = 'running',
  SUCCESS = 'success',
  FAILED = 'failed',
  TERMINATED = 'terminated',
}

export enum AutomationExecutionNodeStatusEnum {
  PENDING = 'pending',
  ABOUT_TO_RUN = 'about_to_run',
  RUNNING = 'running',
  RUNNING_ASYNCHRONOUSLY = 'running_asynchronously',
  WAITING = 'waiting',
  SUCCESS = 'success',
  FAILED = 'failed',
  TERMINATED = 'terminated',
}

export type AutomationExecutionNode = {
  id: string;
  executionStatus: AutomationExecutionNodeStatusEnum;
  additionalOptions: Record<string, any>;
  automationNode: AutomationNodeType;
};

export type AutomationExecutionEdge = {
  id: string;
  executionStatus: AutomationExecutionNodeStatusEnum;
  automationEdge: AutomationEdgeType;
};

export type AutomationExecution = {
  id: string;
  status: AutomationExecutionStatusEnum;
  startsAt: string;
  endsAt: string;

  automation: AutomationType;
  executionNodes: AutomationExecutionNode[];
  executionEdges: AutomationExecutionEdge[];
};
